// Página admin de detalhe do White Label (superAdmin) — wave 1:
// header + tabs (Dados & Tema | Configurações | Métodos |
// Relatórios), todas em modo leitura.
import { useTranslation } from "react-i18next"
import { useParams } from "react-router-dom"

import { AppBreadcrumb } from "@/components/layout/app-breadcrumb"
import { Header } from "@/components/layout/header"
import { FRONTEND_ROUTES } from "@/constants"
import { WhiteLabelDetail } from "@/features/white-label-admin"

export function WhiteLabelDetailPage() {
  const { t } = useTranslation()
  const { uuid } = useParams()

  return (
    <main className="flex w-full flex-1 flex-col">
      <Header>
        <AppBreadcrumb
          links={[
            {
              href: FRONTEND_ROUTES.DASHBOARD.href,
              label: t("sidebar.dashboard"),
            },
            {
              label: t("sidebar.administration"),
            },
            {
              href: FRONTEND_ROUTES.ADMIN_WHITE_LABELS.href,
              label: t("sidebar.whiteLabels"),
            },
            {
              label: t(
                "pages.adminWhiteLabels.detail.breadcrumb"
              ),
            },
          ]}
        />
      </Header>
      <section className="flex flex-1 flex-col gap-4 overflow-x-hidden p-4 @container">
        <WhiteLabelDetail uuid={uuid ?? ""} />
      </section>
    </main>
  )
}
